import React from "react";

import { NavigateCard } from "../../../components/cards";

import * as S from "./styles";

import IProps from "./props";
import { IconName } from "../../../components/cards/navigate-card/props";

interface ICard {
  icon: IconName;
  title: string;
  to: string;
  description: React.ReactNode;
  invertColor?: boolean;
}

const cards: ICard[] = [
  {
    icon: "nf",
    title: "Emitir nota",
    to: "issue",
    description: "Nota fiscal",
  },
  {
    icon: "invoice",
    title: "Emitir invoice",
    to: "invoice",
    description: "Invoice",
    invertColor: true,
  },
  {
    icon: "documents",
    title: "Meus documentos",
    to: "documents",
    description: (
      <>
        Documentos <br /> emitidos
      </>
    ),
  },
];

const HomeDeveloper: React.FC<IProps> = ({ user }) => (
  <S.Container>
    <S.Title>
      Olá {user?.name}, seja bem vindo! <hr />
    </S.Title>
    <S.Cards>
      {cards.map((card) => (
        <NavigateCard {...card}>{card.description}</NavigateCard>
      ))}
    </S.Cards>
  </S.Container>
);
export default HomeDeveloper;
